var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_4135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.6895C18.6274 24.6895 24 19.3169 24 12.6895C24 6.06204 18.6274 0.689453 12 0.689453C5.37258 0.689453 0 6.06204 0 12.6895C0 19.3169 5.37258 24.6895 12 24.6895Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 12.6893H24C24 11.6062 23.8556 10.5569 23.5866 9.55884H11.4783V12.6893Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4783 6.42855H22.2387C21.5041 5.22986 20.5649 4.17035 19.4698 3.2981H11.4783V6.42855Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 24.6895C14.824 24.6895 17.4198 23.7134 19.4697 22.0808H4.53003C6.57987 23.7134 9.17567 24.6895 11.9998 24.6895Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76122 18.9503H22.2387C22.8284 17.988 23.2857 16.9361 23.5865 15.8198H0.41333C0.714127 16.9361 1.17149 17.988 1.76122 18.9503Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55863 2.56342H6.65217L5.63498 3.30241L6.02353 4.49814L5.00639 3.75916L3.98925 4.49814L4.32487 3.46516C3.42928 4.21117 2.64431 5.0852 1.99744 6.05908H2.34783L1.70034 6.52947C1.59947 6.69775 1.50272 6.8687 1.41 7.04219L1.71919 7.9938L1.14234 7.57469C0.998953 7.87848 0.867797 8.18912 0.749906 8.50623L1.09055 9.55474H2.34783L1.33064 10.2937L1.71919 11.4895L0.702047 10.7505L0.0927656 11.1932C0.0317812 11.6834 0 12.1827 0 12.6895H12C12 6.06208 12 5.28077 12 0.689453C9.62944 0.689453 7.41961 1.37711 5.55863 2.56342ZM6.02353 11.4895L5.00639 10.7505L3.98925 11.4895L4.3778 10.2937L3.36061 9.55474H4.61789L5.00639 8.359L5.39489 9.55474H6.65217L5.63498 10.2937L6.02353 11.4895ZM5.63498 6.79806L6.02353 7.9938L5.00639 7.25481L3.98925 7.9938L4.3778 6.79806L3.36061 6.05908H4.61789L5.00639 4.86334L5.39489 6.05908H6.65217L5.63498 6.79806ZM10.3279 11.4895L9.31073 10.7505L8.29359 11.4895L8.68214 10.2937L7.66495 9.55474H8.92223L9.31073 8.359L9.69923 9.55474H10.9565L9.93933 10.2937L10.3279 11.4895ZM9.93933 6.79806L10.3279 7.9938L9.31073 7.25481L8.29359 7.9938L8.68214 6.79806L7.66495 6.05908H8.92223L9.31073 4.86334L9.69923 6.05908H10.9565L9.93933 6.79806ZM9.93933 3.30241L10.3279 4.49814L9.31073 3.75916L8.29359 4.49814L8.68214 3.30241L7.66495 2.56342H8.92223L9.31073 1.36769L9.69923 2.56342H10.9565L9.93933 3.30241Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_4135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.1ccdad07a6d1b05a490bdc24250bbb2e.svg";
export { ForwardRef as ReactComponent };